// extracted by mini-css-extract-plugin
export default {"root":"CanselUpdateModal_root__ZNaIa","wrapper":"CanselUpdateModal_wrapper__vCRgV","wrapperBtn":"CanselUpdateModal_wrapperBtn__VJDd5","btn":"CanselUpdateModal_btn__tHKXt"};